import {
  faCircle,
  // faFilter,
  faFolder
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import QuizzesTopicFilterModal from 'components/modals/QuizzesTopicFilterModal';
import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

const QuizzesTopicFilter = ({
  role,
  onSearchChange
}: {
  role?: string;
  onSearchChange: Dispatch<SetStateAction<string>>;
}) => {
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };
  return (
    <Row className="g-3 justify-content-between mb-4">
      <Col xs="auto">
        <div className="d-flex align-items-center gap-3">
          {role && (
            <div className="fw-semibold fs-9">
              <FontAwesomeIcon icon={faFolder} className="me-2" />
              {role}
            </div>
          )}
          <OverlayTrigger
            overlay={
              <Tooltip>
                Essential skills that must be completed to progress in the
                assessment.
              </Tooltip>
            }
          >
            <div className="d-flex align-items-center">
              <FontAwesomeIcon
                icon={faCircle}
                transform="shrink-6 up-1"
                className="me-1 text-danger"
              />
              <span className="fw-bold fs-9 text-body lh-2">Critical Tech</span>
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            overlay={
              <Tooltip>
                Additional skills that enhance your profile but are not
                mandatory.
              </Tooltip>
            }
          >
            <div className="d-flex align-items-center">
              <FontAwesomeIcon
                icon={faCircle}
                transform="shrink-6 up-1"
                className="me-1 text-warning"
              />
              <span className="fw-bold fs-9 text-body lh-2">
                Supplementary Tech
              </span>
            </div>
          </OverlayTrigger>
        </div>
      </Col>
      <Col xs="auto">
        <div className="d-flex">
          <SearchBox
            placeholder="Search by name"
            className="me-2"
            onChange={handleSearchInputChange}
          />
          {/* <Button
            variant="phoenix-secondary"
            className="px-3"
            onClick={() => setOpenFilterModal(true)}
          >
            <FontAwesomeIcon
              icon={faFilter}
              transform="down-3"
              className="text-primary"
            />
          </Button> */}
        </div>
        <QuizzesTopicFilterModal
          show={openFilterModal}
          handleClose={() => setOpenFilterModal(false)}
        />
      </Col>
    </Row>
  );
};

export default QuizzesTopicFilter;
